/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UboSuggestionResource
 */
export interface UboSuggestionResource {
    /**
     * 
     * @type {string}
     * @memberof UboSuggestionResource
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UboSuggestionResource
     */
    lastName: string;
    /**
     * Partial or full date as returned by provider (e.g. '1997-09' for YYYY-MM or '1997-09-15' for YYYY-MM-DD)
     * @type {string}
     * @memberof UboSuggestionResource
     */
    dateOfBirth?: string;
    /**
     * 2-letter ISO 3166 country code
     * @type {string}
     * @memberof UboSuggestionResource
     */
    nationalityCode?: string;
    /**
     * 
     * @type {number}
     * @memberof UboSuggestionResource
     */
    percentageOfShares?: number;
    /**
     * 
     * @type {string}
     * @memberof UboSuggestionResource
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof UboSuggestionResource
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof UboSuggestionResource
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UboSuggestionResource
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UboSuggestionResource
     */
    countryCode?: string;
}

/**
 * Check if a given object implements the UboSuggestionResource interface.
 */
export function instanceOfUboSuggestionResource(value: object): value is UboSuggestionResource {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function UboSuggestionResourceFromJSON(json: any): UboSuggestionResource {
    return UboSuggestionResourceFromJSONTyped(json, false);
}

export function UboSuggestionResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboSuggestionResource {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'nationalityCode': json['nationalityCode'] == null ? undefined : json['nationalityCode'],
        'percentageOfShares': json['percentageOfShares'] == null ? undefined : json['percentageOfShares'],
        'addressLine1': json['addressLine1'] == null ? undefined : json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
    };
}

export function UboSuggestionResourceToJSON(value?: UboSuggestionResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'dateOfBirth': value['dateOfBirth'],
        'nationalityCode': value['nationalityCode'],
        'percentageOfShares': value['percentageOfShares'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'postalCode': value['postalCode'],
        'city': value['city'],
        'countryCode': value['countryCode'],
    };
}

